// eslint-disable-next-line no-restricted-imports
import { Configuration, UserApi as ConsentApi, UserApiAcceptUserConsentRequest } from '@eih-netbroker/api-consent';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';

export type AcceptConsentRequest = Omit<UserApiAcceptUserConsentRequest, keyof ResourceHeadersWithToken>;

export class ConsentResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'ConsentResource';
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private consentApi: ConsentApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, `${basePath}${configApi.usUrl.consent}`, configApi);
    this.consentApi = new ConsentApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.consent}`,
      }),
      `${basePath}${configApi.usUrl.consent}`,
      axiosInstance,
    );
  }

  getConsent(userId: string, headers: ResourceHeadersWithToken) {
    return this.consentApi.getUserConsents(
      { ...headers, userId, showNotAccepted: true },
      { baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.consent}` },
    );
  }

  acceptConsent(request: AcceptConsentRequest, headers: ResourceHeadersWithToken) {
    return this.consentApi.acceptUserConsent(
      { ...request, ...headers },
      { baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.consent}` },
    );
  }

  resetConsentApprove(request: AcceptConsentRequest, headers: ResourceHeadersWithToken) {
    return this.consentApi.revokeUserConsent(
      { ...request, ...headers },
      { baseURL: `${this.configApi.usUrl.baseUrl}${this.configApi.usUrl.consent}` },
    );
  }
}
